// @flow

import React from "react";

import GlobalSettingsStore from "app/stores/GlobalSettingsStore";

import Video from "app/models/Video";

import ImageHelper from "app/util/ImageHelper";

import VideoCard from "app/components/VideoCard/VideoCard";
import CreateStory from "app/components/CreateStory/CreateStory";

import replayIcon from "./images/replay.png";
import shareIcon from "./images/share.png";

import "./VideoEnding.scss";

type Props = {
    video: Video,
    card: boolean,
    onReplay: Function,
    onShare: Function
};

export default class VideoEnding extends React.PureComponent<Props> {
    render() {
        const video = this.props.video;

        let thumbnail;
        if (video.thumbnail) {
            thumbnail = ImageHelper.makeUrl(video.thumbnail, "jpg", {
                width: 400
            });
        } else {
            thumbnail = video.source_thumbnail;
        }
        return (
            <div className="VideoEnding">
                <div
                    className="VideoEnding__background"
                    style={{ backgroundImage: `url(${thumbnail})` }}
                />

                {this.renderVideoCard()}

                <div className="VideoEnding__actions">
                    <button
                        className="VideoEnding__action"
                        onClick={this.props.onReplay}
                    >
                        <img src={replayIcon} alt="replay" /> Replay video
                    </button>

                    <button
                        className="VideoEnding__action"
                        onClick={this.props.onShare}
                    >
                        <img src={shareIcon} alt="share" /> Share video
                    </button>
                </div>
            </div>
        );
    }

    renderVideoCard() {
        if (!this.props.card) return false;

        const video = this.props.video;
        return (
            <div className="VideoEnding__card">
                <VideoCard
                    video={video}
                    serverTime={null}
                    theme={GlobalSettingsStore.videoCardTheme}
                    withoutUrl={true}
                />

                <div className="VideoEnding__card-text">
                    Feel like annotating this video too?
                </div>

                <CreateStory
                    text="Create your own version!"
                    icon="check"
                    url={video.url}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/components/VideoEnding/VideoEnding.js